import { Dialog } from 'antd-mobile';
import { AliasToken } from 'antd/es/theme/internal';

import { ModalIcon, Wrapper } from './MobileDialog.styled';

interface MobileDialogProps {
  onConfirm: () => void;
  confirmText: string;
  cancelText: string;
  title: string;
  description: string | React.ReactNode;
  theme: AliasToken;
}

export const MobileDialog = (props: MobileDialogProps) => {
  const { onConfirm, confirmText, cancelText, title, description, theme } = props;

  return Dialog.show({
    content: (
      <Wrapper>
        <ModalIcon style={{ color: theme.colorWarning }} />
        <h5 style={{ fontWeight: 500, fontSize: 15 }}>{title}</h5>
        <span style={{ fontSize: 15 }}>{description}</span>
      </Wrapper>
    ),
    closeOnAction: true,
    actions: [
      [
        {
          key: 'cancel',
          text: cancelText,
          style: {
            color: theme.colorPrimary,
          },
        },
        {
          key: 'confirm',
          text: confirmText,
          onClick: onConfirm,
          danger: true,
        },
      ],
    ],
  });
};
